import { SET_APP_FEATURES } from "../actions/ActionTypes";

const initialState = {
  features: null,
};

const AppFeaturesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_FEATURES:
      return { ...state, features: action.payload };
    default:
      return state;
  }
};

export default AppFeaturesReducer;
